/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_DescriptionInputs */

const en_agent_authorization_description = /** @type {(inputs: Agent_Authorization_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the project and permissions below. Nothing is authorized until you select Approve and continue.`)
};

const zh_agent_authorization_description = /** @type {(inputs: Agent_Authorization_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请核对下面的项目和权限。只有点击“批准并继续”后，授权才会生效。`)
};

/**
* | output |
* | --- |
* | "Review the project and permissions below. Nothing is authorized until you select Approve and continue." |
*
* @param {Agent_Authorization_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_description = /** @type {((inputs?: Agent_Authorization_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_description(inputs)
	return zh_agent_authorization_description(inputs)
});
export { agent_authorization_description as "agent.authorization.description" }